import { FC, FocusEventHandler, useRef } from 'react'

import { styled } from 'styled-components'

type BorrowerSearchQuickPrefixButtonProps = {
  onClick: (prefix: string) => void
  prefix: string
  usedPrefixes: Array<string>
}

const BorrowerSearchQuickPrefixButton: FC<
  BorrowerSearchQuickPrefixButtonProps
> = ({ onClick, prefix, usedPrefixes }) => {
  const buttonRef = useRef<HTMLButtonElement>(null)

  const handleButtonFocus: FocusEventHandler<HTMLButtonElement> = () => {
    if (buttonRef.current) buttonRef.current.scrollIntoView()
  }

  return (
    <StyledToolbarButton
      disabled={usedPrefixes.includes(prefix)}
      onClick={() => onClick(prefix)}
      onFocus={handleButtonFocus}
      ref={buttonRef}
    >
      {prefix}
    </StyledToolbarButton>
  )
}

export default BorrowerSearchQuickPrefixButton

export const StyledToolbarButton = styled.button`
  border-width: 1px;
  border-style: solid;
  border-radius: 6px;
  background: ${(p) => p.theme.background};
  padding: 3px 4px;

  &:disabled {
    border-color: ${(p) => p.theme.border};
    cursor: not-allowed;
    color: ${(p) => p.theme.disabledText};
  }

  &:not(:disabled) {
    border-color: ${(p) => p.theme.border};
    cursor: pointer;
    color: ${(p) => p.theme.labelText};

    &:hover,
    &:focus {
      border-color: ${(p) => p.theme.highlight};
    }
  }

  & + & {
    margin-left: 4px;
  }
`
